import useCollection from "./useCollection";

export default function CollectionImage({
    className = "",
}) {

    const collection = useCollection();

    if (!collection?.image)
        return null;

    return (
        <div className={`collection-image ${className}`}>

            <img
                src={`${collection.image}`}
                alt={collection.title}
                className="products-category-image"
            />

        </div>
    );
}